import styled from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 6px;
  width: 46px;
  height: 33px;
  border: 1px solid #EEEEEE;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.07);
  color: ${window?.settings?.secondary_color ?? '#04333b'};

  margin-left: 8px;
  margin-right: 8px;
  cursor: pointer;
`;

export default Wrapper(template)